import Swipeable from "./Swipeable";

export default Swipeable;
